import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import useCountDown from 'utilities/hooks/countDown'
import UseSendConfirmation from './hooks/useSendConfirmation'
import UseSendCode from './hooks/useSendCode'
import ConfirmationHeader from './header'
import ReactCodeInput from 'react-code-input'
import styles from './confirmation.module.scss'
import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'

export default function Confirmation() {
    const [confirmCode, setConfirmCode] = useState<string>('')
    const location = useLocation()
    const navigate = useNavigate()
    const mobile = location.state?.mobile
    const [isSubmit, setIsSubmit] = useState<boolean>(false)

    const { currentMinutes, currentSeconds, startHandler, isRunning } =
        useCountDown()
    const { mutate } = UseSendConfirmation(setIsSubmit, mobile)
    const { isLoading: sendCodeLoading, mutate: sendCodeMutate } = UseSendCode()

    useEffect(() => {
        if (confirmCode.length === 4 && !isSubmit) {
            setIsSubmit(true)
            mutate({ code: toEnglishDigits(confirmCode), phone_number: mobile })
        }
    }, [confirmCode])

    useEffect(() => {
        startHandler()
    }, [])

    const sendCode = () => {
        sendCodeMutate({ phone_number: mobile })
        startHandler()
    }
    return (
        <>
            <div className="flex flex-col items-center h-screen relative mx-6 ">
                <div className="w-full">
                    <ConfirmationHeader phone={mobile} />
                    <form className="">
                        <div
                            className="mt-3 text-center flex justify-center w-full"
                            dir="ltr"
                        >
                            <div>
                                <ReactCodeInput
                                    value={confirmCode}
                                    name="confirmCode"
                                    fields={4}
                                    className={styles['reactCode-input']}
                                    inputMode="numeric"
                                    onChange={(e) => setConfirmCode(e)}
                                />
                            </div>
                        </div>
                        <div className=" text-center mt-4">
                            <p
                                className=" text-blue-1 text-sm"
                                onClick={() => navigate(-1)}
                            >
                                ویرایش شماره موبایل
                            </p>
                        </div>
                        <div className=" pt-4 tex-gray-6 w-full text-center text-gray-3">
                            {isRunning ? (
                                <>
                                    <span className="ps-2 text-center text-gray-3">
                                        ارسال مجدد:
                                    </span>{' '}
                                    {currentSeconds} : {currentMinutes}
                                </>
                            ) : (
                                <>
                                    {sendCodeLoading ? (
                                        <p className="text-center">loading</p>
                                    ) : (
                                        <u
                                            onClick={sendCode}
                                            className=" text-cyan-2 no-underline"
                                        >
                                            ارسال مجدد
                                        </u>
                                    )}
                                </>
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
